const ServiceIcon = ({ value, classname }) => (
  <div className={`dot bigger ${classname}`}>
    <div>{value}</div>
  </div>
)

export default ServiceIcon
